const defaultTableColumns = [
    {
        title: 'Ordem',
        data: 'order',
        sortable: true
    },
    {
        title: 'Código',
        data: 'id',
        sortable: true
    },
    {
        title: 'Cliente',
        data: 'customer.name',
        sortable: true
    },
    {
        title: 'CPF',
        data: 'customer.cpf',
        sortable: true
    },
    {
        title: 'Celular',
        data: 'customer.cellphone',
        sortable: true
    },
    {
        title: 'Credenciamento',
    },
    {
        title: 'Chamada',
    },
    {
        title: 'Reserva de Unidade',
    },
    {
        title: 'Validação de Cliente',
    },
    {
        title: 'Realizar Pagamento',
    },
    {
        title: 'Situação',
        data: 'situation',
        sortable: true
    },
    {
        title: 'Reservas',
        data: 'u.name',
        sortable: true
    },
    {
        title: 'Etapa',
        data: 'deal.funnel_stage',
        sortable: true
    },
    {
        title: 'Status',
        data: 'deal.funnel_stage_status',
        sortable: true
    },
    {
        title: 'Responsável',
        data: 'deal.owner',
        sortable: true
    },
    {
        title: '',
        size: '40',
    },
]

const filters = [
    {
        component: 'select-tags',
        label: "Ponto de Atendimento",
        disabled: false,
        hidden: false,
        options: [
            { label: 'Credenciamento', value: 'credenciamento', id: 0 },
            { label: 'Reserva de Unidade', value: 'reserva', id: 1 },
            { label: 'Validação de Cliente', value: 'validacao', id: 2 },
            { label: 'Realizar Pagamento', value: 'pagamento', id: 3 },
            { label: 'Chamada', value: 'chamado', id: 4 }
        ],
        returnValue: 'value',
        params: {
            name: 'control',
            value: null
        },
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Situação",
        disabled: false,
        hidden: false,
        multiple: true,
        options: [
            { label: 'Ausente', value: 'ausente', id: 0 },
            { label: 'Presente', value: 'presente', id: 1 },
        ],
        returnValue: 'value',
        params: {
            name: 'situation',
            value: null
        },
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Quadra/Torre",
        disabled: false,
        hidden: false,
        handler: 'blockHandler',
        service: 'availability',
        method: 'getBlocks',
        itemLabel: 'label',
        searchAble: true,
        serviceParams: [],
        options: [],
        parse(data) {
            return Object.values(data).map(option => {
                return { label: `Quadra/Torre ${option.block}`, value: option.block }
            })
        },
        returnValue: 'value',
        params: {
            name: 'block',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Lote/Unidade",
        disabled: true,
        hidden: false,
        itemLabel: 'number',
        searchAble: true,
        options: [],
        returnValue: 'id',
        params: {
            name: 'unit_id',
            value: null
        },
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Etapa",
        disabled: false,
        hidden: false,
        service: 'funnel',
        method: 'getStages',
        itemLabel: 'name',
        searchAble: false,
        multiple: false,
        handler: 'funnelStageHandler',
        options: [],
        returnValue: 'id',
        params: {
            name: 'funnel_stage_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Status",
        disabled: true,
        hidden: false,
        itemLabel: 'name',
        searchAble: true,
        multiple: true,
        options: [],
        returnValue: 'id',
        params: {
            name: 'funnel_stage_status_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Equipe",
        disabled: false,
        hidden: false,
        handler: 'teamHandler',
        service: 'team',
        method: 'getAll',
        itemLabel: 'name',
        searchAble: true,
        multiple: false,
        serviceParams: ['', { nocover: true, per_page: 1000 }],
        options: [],
        returnValue: 'id',
        params: {
            name: 'team_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Gerente",
        disabled: true,
        hidden: false,
        handler: 'managerHandler',
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'manager_id',
        params: {
            name: 'manager_id',
            value: ''
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
    {
        component: 'select-tags',
        label: "Corretor",
        disabled: true,
        hidden: false,
        itemLabel: 'first_name',
        searchAble: true,
        multiple: false,
        options: [],
        returnValue: 'broker_id',
        params: {
            name: 'broker_id',
            value: null
        },
		requestOnStart: true,
		alreadyRequested: false,
		loading: false,
    },
]

export { defaultTableColumns, filters }